
// @ is an alias to /src
import { defineComponent } from 'vue';
import commonApi from '@/api/common';
import { message as $message } from 'ant-design-vue';
import Cooperation from '@/components/cooperation.vue';
import privacy from '@/untils/privacy';
import environment from '@/untils/environment';
import userArg from '@/untils/userAgreement';

export default defineComponent({
  name: 'Register',
  components: {
    Cooperation,
  },
  data() {
    return {
      loginState: 'login',
      isPassWord: false,
      mobile: '',
      password: '',
      confirmPassword: '',
      validCode: '',
      parentInviteCode: '',
      checked: false,
      visible: false,
      title: '',
      content: '',
      countNum: 60,
      isShowTimer: false,
      loading: false,
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
    registerShop() {
      if (!this.mobile) {
        this.error('请输入用户名');
        return;
      }
      if (!this.validCode) {
        this.error('请输入验证码');
        return;
      }
      if (!this.password) {
        this.error('请输入登录密码');
        return;
      }
      if (!this.confirmPassword) {
        this.error('请再次输入登录密码');
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.error('两次密码输入不一致，请重新输入');
        return;
      }
      if (!this.checked) {
        this.error('请勾选用户协议，隐私政策');
        return;
      }
      const parm = {
        mobile: this.mobile,
        validCode: this.validCode,
        password: this.password,
        confirmPassword: this.confirmPassword,
        parentInviteCode: this.parentInviteCode,
      };
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      commonApi.registerShop(parm).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.loading = true;
          // this.goToLogin();
          setTimeout(() => {
            this.success('注册成功');
            this.logIn();
          }, 3000);
        } else {
          this.error(message);
        }
      });
    },
    getRegisterCode() {
      if (!this.mobile) {
        this.error('请输入手机号码');
        return;
      }
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      const param = {
        mobile: this.mobile,
      };
      this.countNum = 60;
      commonApi.sendRegisterCode(param).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          this.isShowTimer = true;
          const Timer = setInterval(() => {
            if (this.countNum === 0) {
              clearInterval(Timer);
              this.isShowTimer = false;
            } else {
              this.countNum -= 1;
            }
          }, 1000);
        } else {
          console.log(message);
          this.error(message);
        }
      });
    },
    ViewRelatedInformation(num: number) {
      if (num === 0) {
        this.title = '用户协议';
        this.content = userArg;
      } else {
        this.title = '隐私政策';
        this.content = privacy;
      }
      this.visible = true;
    },
    logIn() {
      const parm = {
        mobile: this.mobile,
        validCode: this.validCode,
        password: this.password,
      };
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      commonApi.login(parm).then(async ({ data, success, message }: Data) => {
        if (success) {
          const {
            accountId, memberId, token, siteId,
          } = data;
          console.log(data);
          localStorage.setItem('accountId', accountId);
          localStorage.setItem('memberId', memberId);
          localStorage.setItem('token', token);
          localStorage.setItem('siteId', siteId);
          this.getShopInfo();
        } else {
          this.error(message);
          // this.$message.error(message);
        }
      });
    },
    getShopInfo() {
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      const param = {
        memberId: localStorage.getItem('memberId'),
      };
      commonApi.getShopInfo(param).then(async ({ data, success, message }: Data) => {
        if (success) {
          if (!data.shopName) {
            this.$router.push('/');
          } else {
            const accountId = await localStorage.getItem('accountId');
            const memberId = await localStorage.getItem('memberId');
            const token = await localStorage.getItem('token');
            const siteId = await localStorage.getItem('siteId');
            setTimeout(() => {
              const loc = window.location;
              const uri = loc.host;
              const url = `http://${uri.indexOf('pre') === -1 ? 'hdsupport.saas.seatent.com' : 'hdsupport.saas.saaspre.seatent.com'}/#/callback?randomCode=42rfmhh9x73juwvw&approach=22&token=${token}&accountId=${accountId}&appkey=${environment.appkey}&siteId=${siteId}&memberId=${memberId}&link=/home/go`;
              console.log(url);
              window.location.href = url;
            }, 50);
          }
        } else {
          console.log(message);
          this.error(message);
        }
      });
    },
  },
});
